import React, { useState } from "react";
import IconThreeDots from "../../../layout/others/three-dots.svg";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { InterviewService } from "../../../services/InterviewService";
import { toast } from "react-toastify";
import { showWarning } from "../../../services/ModalService";
import ModalDNASentSuccessfully from "../../Interview/InterviewOptions/ModalDNASentSuccessfully";

export function ThreeDotsDropDownMibilityInternational({
  interview,
  openCreateInterviewInOtherCompany
}) {
  const [shoModalSendDNA, setShowModalSendDNA] = useState(false);
  const { t } = useTranslation();

  function submitSendDocOnline() {
    InterviewService.sendDocOnline({
      interviewId: interview.interviewId,
      generatedLanguageId: interview.docOnlineLanguageId
    }).then((data) => {
      if (data === undefined) {
        setShowModalSendDNA(true);
      }
    });
  }

  function sendDocOnline() {
    if (
      !interview.personalInformation.fullName &&
      interview.personalInformation.emailAddress
    ) {
      toast.warning(
        `${t("Please fill in the name and email to send the Doc Online!")}`
      );
      return;
    }
    if (
      interview.hasPendingDocOnline === true ||
      interview.docOnlineStatus === "Expired"
    ) {
      showWarning(
        t(
          "A docOnline was already sent, do you wish to send another docOnline?"
        ),
        submitSendDocOnline
      );
      return;
    } else {
      submitSendDocOnline();
    }
  }

  return interview ? (
    <>
      <div className="btn-group dropstart" style={{ marginTop: "17px" }}>
        <button
          type="button"
          className="action-button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <img src={IconThreeDots} alt="threedots" title={t("Options")} />
        </button>
        <ul className="dropdown-menu">
          <li>
            <button
              className="dropdown-item"
              type="button"
              onClick={() => {
                sendDocOnline();
              }}
            >
              {t("Send Doc Online")}
            </button>
          </li>
          <li>
            <button
              className="dropdown-item"
              type="button"
              onClick={openCreateInterviewInOtherCompany}
            >
              {t("Share to another company")}
            </button>
          </li>
        </ul>
      </div>
      <ModalDNASentSuccessfully
        showModal={shoModalSendDNA}
        setShowModal={setShowModalSendDNA}
      />
    </>
  ) : (
    <></>
  );
}

export default ThreeDotsDropDownMibilityInternational;

ThreeDotsDropDownMibilityInternational.propTypes = {
  sendDocOnline: PropTypes.func.isRequired
};
